import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	getAttributeOrThrow,
	qsaOptional, qsOptional,
	qsRequired, qsRequiredFromDocument, setupQuizTriggers,
} from '@/scripts/core/global'
import { getSectionHTMLForResource } from '@/scripts/core/cart-functions'
import type { StickyHeader } from '@/scripts/theme/sticky-header'

export class DynamicCollection extends UcoastEl {
	static htmlSelector = 'dynamic-collection'
	titleTextEl: HTMLElement
	dynamicArea: HTMLElement
	dynamicNav?: HTMLElement
	dynamicLinks?: NodeListOf<HTMLAnchorElement>
	initialOffsetTop?: number
	isSticky: boolean
	sectionId: string
	constructor() {
		super()
		this.sectionId = getAttributeOrThrow('data-section-id', this)
		this.isSticky = false
		this.dynamicLinks = qsaOptional<HTMLAnchorElement>('[data-dynamic-collection-link]', this)
		this.dynamicArea = qsRequired<HTMLElement>('[data-dynamic-collection-area]', this)
		this.titleTextEl = qsRequired<HTMLElement>('[data-dynamic-collection-title]', this)
		this.dynamicNav = qsOptional<HTMLElement>('[data-dynamic-collection-nav]', this)
		if (this.dynamicNav) {
			this.initialOffsetTop = this.dynamicNav.offsetTop
		}
		if (!this.dynamicLinks) return
		this.dynamicLinks.forEach((link) => {
			link.addEventListener('click', this.loadCollection.bind(this))
		})
	}

	async loadCollection(event: Event) {
		event.preventDefault()
		const target = event.target as HTMLAnchorElement
		const url = getAttributeOrThrow('href', target)
		this.dynamicArea.classList.add('loading')
		this.titleTextEl.innerHTML = target.innerHTML
		this.dynamicLinks?.forEach((link) => {
			if (link.getAttribute('href') === url) {
				link.classList.add('active')
				link.classList.remove('underline-on-hover')
				link.classList.add('underline-always')
				link.setAttribute('aria-current', 'page')
			} else {
				link.classList.remove('active')
				link.classList.remove('underline-always')
				link.classList.add('underline-on-hover')
				link.removeAttribute('aria-current')
			}
		})
		const stickyHeader = qsRequired<StickyHeader>('sticky-header')
		stickyHeader.beforeAnchorScroll()

		const html = await getSectionHTMLForResource(url, this.sectionId)
		if (!html || !this.dynamicLinks) {
			this.dynamicArea.classList.remove('loading')
			return
		}
		const dom = new DOMParser().parseFromString(html, 'text/html')
		const area = qsRequiredFromDocument('[data-dynamic-collection-area]', dom)
		this.dynamicArea.innerHTML = area.innerHTML
		this.scrollIntoView({ behavior: 'smooth', block: 'start' });

		await window.Ucoast.mediaManager.loadAllInContainer(this.dynamicArea)
		this.dynamicArea.classList.remove('loading')
		history.pushState(null, '', url);
		setupQuizTriggers(this.dynamicArea)
	}
	onHeaderScrollEvent() {
		if (!this.dynamicNav) return
		if (this.initialOffsetTop !== this.dynamicNav.offsetTop) {
			if (this.isSticky) return
			this.isSticky = true
			this.dynamicNav.classList.add('sticky')
		} else {
			if (!this.isSticky) return
			this.isSticky = false
			this.dynamicNav.classList.remove('sticky')
		}
	}
}
